import { render, staticRenderFns } from "./RWSBeheerLayer.vue?vue&type=template&id=6233c78a&"
import script from "./RWSBeheerLayer.vue?vue&type=script&lang=js&"
export * from "./RWSBeheerLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports